import { forwardRef, InputHTMLAttributes } from 'react';
import { cn } from './cn';

export type InputSize = 'sm' | 'md' | 'lg';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  inputSize?: InputSize;
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { inputSize = 'md', invalid, className, ...rest },
  ref
) {
  return (
    <input
      ref={ref}
      data-tss-ui=""
      data-size={inputSize}
      data-invalid={invalid || undefined}
      className={cn('tss-input', className)}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  );
});
